var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.blobUrl)?_c('iframe',{ref:"iframeRef",staticStyle:{"width":"100%","height":"100dvh"},attrs:{"src":_vm.blobUrl},on:{"load":_vm.printIframe}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }